import { useTranslate } from 'react-polyglot';

import { BasicParagraph, BigParagraph } from '@genially/design-system';

import {
  ErrorInfoWrapper,
  StyledResponsiveText,
  StyledWarningBasicIcon,
} from './UsernameIsTakenError.styled';

export const UsernameIsTakenError = () => {
  const t = useTranslate();

  return (
    <ErrorInfoWrapper>
      <StyledWarningBasicIcon />

      <StyledResponsiveText with={BigParagraph} on={{ xs: BasicParagraph }}>
        {t('__new.play.playerAccess.username.error')}
      </StyledResponsiveText>
    </ErrorInfoWrapper>
  );
};
